import module from 'fan/proyecto/module.js'
import * as moment from 'moment'


export const FanProyectoCatalogosMigrarSchema = {
  id: 'number',
  cuentas_bancarias: 'boolean',
}

export class FanProyectoColaboradoresMigrarService  {
  constructor ($http) {
    this.$http = $http
  }

  post (fecha_alta, fecha_baja, destino, origen, colaboradores, notas, cuentasBancarias) {
    return this.$http.post(`/api2/proyecto/colaboradores/migrar`, colaboradores ,{
      params: {destino, origen, fecha_alta: moment(fecha_alta).format('YYYY-MM-DD'), fecha_baja: moment(fecha_baja).format('YYYY-MM-DD'), notas, cuentas_bancarias: cuentasBancarias},
      schema: FanProyectoCatalogosMigrarSchema,
    })
  }
}

module.service('FanProyectoColaboradoresMigrarService', FanProyectoColaboradoresMigrarService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores/Migrar.js